import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { ApiService } from '../../../../core/services/api.service';
import { ILegalTermsFormPayload, ILegalTermsListBody, ILegalTermsListResponse } from '../models/legal-terms.models';

@Injectable({
	providedIn: 'root',
})
export class LegalTermsService extends ApiService {
	// TODO: Tipar
	public list(body: any): Observable<ILegalTermsListResponse> {
		return this.http.post<ILegalTermsListResponse>(environment.apiUrl + `/policy-checks`, body, {
			headers: this.getHeaders(),
		});
	}

	public get(uuid: string, params?: Record<string, string>): Observable<ILegalTermsListBody> {
		return this.http
			.get<{ data: ILegalTermsListBody }>(`${environment.apiUrl}/policy-check/${uuid}`, {
				headers: this.getHeaders(),
				params,
			})
			.pipe(map((r) => r.data));
	}

	public create(body: ILegalTermsFormPayload): Observable<any> {
		return this.http.post<any>(environment.apiUrl + `/policy-check/create`, body, {
			headers: this.getHeaders(),
		});
	}

	public update(id: any, body: ILegalTermsFormPayload): Observable<any> {
		return this.http.patch<any>(environment.apiUrl + `/policy-check/${id}`, body, {
			headers: this.getHeaders(),
		});
	}

	public delete(id: string): Observable<any> {
		return this.http.delete<any>(environment.apiUrl + `/policy-check/${id}`, {
			headers: this.getHeaders(),
		});
	}
}
